/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/userLists.config.json";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_MASQUERADER, GET_PRESENTATIONS } from "../graphql";
import { pretty } from "@vlinder-web/utils-react";

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};
const iso3166 = require("iso-3166-1-alpha-2");
export interface ITableMethods extends IPluginMethodMap {
  getTableProps(args: any): Promise<any>;
}

export class TableService implements IAgentPlugin {
  readonly methods: ITableMethods;

  constructor() {
    this.methods = {
      getTableProps: this.getProps.bind(this),
    };
  }

  async getProps(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const _filter = {
      year: {
        eq: "2024"
      },
      status: {
        eq: "active",
      },
    };
    let filter = {}
    if (args?.criteria?.country) {
      filter = {
        ...filter,
        User___address___country: {
          eq: args?.criteria?.country,
        },
      }
    }
    console.log("args?.criteria==>", args?.criteria);
    let options = {
      sort: {
        field: "User.address.country",
        order: "asc"
      },
      limit: args?.size ?? 10,
      skip: args?.offset ?? 0,
    };
    try {
      if (client) {
        const presentation = await client.query({
          query: GET_PRESENTATIONS,
          variables: {
            filter: _filter,
            options: {
              limit: args?.size ?? 10,
              skip: args?.offset ?? 0,
            },
          },
          fetchPolicy: "network-only",
        });
        let defaultPresentation =
          presentation?.data?.getPresentations?.content[0]?.id;
        if (args?.criteria?.presentation) {
          defaultPresentation = args?.criteria?.presentation;
        }
        console.log("presentationdefault==>", pretty(args?.criteria), defaultPresentation)
        filter = {
          ...filter,
          presentation: {
            eq: defaultPresentation,
          },
        }
        const _res = await client.query({
          query: GET_MASQUERADER,
          fetchPolicy: "network-only",
        });
        const res = await client.query({
          query: GET_MASQUERADER,
          variables: {
            filter: filter,
            options: options,
          },
          fetchPolicy: "network-only",
        });
        if (res?.data) {
          const _table = this.tableFormat(
            res?.data?.getUserAdvancedSearch?.content
          );
          const _search = this.SearchFormat(
            _res?.data?.getUserAdvancedSearch?.content
          );
          let _totalPages = res?.data?.getUserAdvancedSearch?.count
            ? Math.ceil(parseInt(res?.data?.getUserAdvancedSearch?.count) / 10)
            : 1;

          let _currentPage =
            res?.data?.getUserAdvancedSearch?.skip /
            res?.data?.getUserAdvancedSearch?.limit +
            1;
          return {
            ...config,
            ultUsers: _table,
            isEmpty: res?.data?.getUserAdvancedSearch?.content?.length <= 0,
            activePage: _currentPage,
            currentPage: _currentPage,
            pageSize: res?.data?.getUserAdvancedSearch?.limit,
            totalCount: res?.data?.getUserAdvancedSearch?.count,
            totalPages: _totalPages,
            searchStatusFilter: _search,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
    // return {...(config || {})}
  }

  private tableFormat(data: any) {
    let getCountryNames = new Intl.DisplayNames(["en"], { type: "region" });
    const isISO2CountryCode = (code: any) => {
      var pattern = /^[A-Za-z]{2}$/;
      return pattern.test(code);
    };

    let users: any[] = [];
    data.forEach((item: any) => {
      let cty = item?.User?.address?.country ?? null;
      if (cty !== null && isISO2CountryCode(cty)) {
        cty = getCountryNames.of(cty.toUpperCase());
      }
      users.push({
        id: item?.id ?? "-",
        name: item?.User?.fullName ?? "Null Null",
        email: item?.User?.email ?? "-",
        gender: item?.User?.gender ?? "-",
        section: item?.Section?.name ?? "-",
        costume: item?.CostumeType?.name ?? "-",
        paymentStatus: item?.paymentStats ?? "-",
        state: item?.User?.address?.state ?? "-",
        country: cty ?? item?.User?.address?.country ?? "-",
      });
    });
    return users;
  }

  private SearchFormat(data: any) {
    let getCountryNames = new Intl.DisplayNames(["en"], { type: "region" });
    const isISO2CountryCode = (code: any) => {
      var pattern = /^[A-Za-z]{2}$/;
      return pattern.test(code);
    };
    let users: any[] = [];
    let options: any[] = [];
    data.forEach((item: any) => {
      if (item?.User?.address?.country) {
        users.push(item?.User?.address?.country);
      }
    });
    const country = Array.from(new Set(users));
    country.sort();
    country.forEach((item: any) => {
      let cty: boolean = isISO2CountryCode(item);
      let _cty: any = null;
      if (cty) {
        _cty = getCountryNames.of(item.toUpperCase());
      }
      options.push({
        value: item,
        label: _cty !== null ? _cty : item,
      });
    });
    console.log("search==>", options);
    return options;
  }
}
